import { ValidationItemContainer } from "../../../../reporting/report-lists/reports/copyto/CompanyMultipleReportsListItemContainer";
import { ReportInProgress } from "../../../../reporting/report-lists/reports/copyto/controls/ReportInProgress";
import type { CopyCompanyDashboard, CopyCompanyTile } from "../../hooks/CopyCompany";
import { Copied } from "../Copied";
import { CopyError } from "../CopyError";
import { CopyWaiting } from "../CopyWaiting";
import { ReportNotConfigured } from "../ReportNotConfigured";

interface Props {
  tile: CopyCompanyTile;
  dashboard: CopyCompanyDashboard;
}

export const SmartViewTileItemCopying = ({ tile, dashboard }: Props) => {
  const report = tile.tile.report;
  const isCopied = dashboard.copied && tile.copied;

  if (!report) {
    return <ReportNotConfigured companyTile={tile.tile} />;
  }

  return (
    <ValidationItemContainer caption={tile.tile.tile.widget.nameUserInput || "(No name)"} completed={tile.copied}>
      {tile.copying && <ReportInProgress text="Copying..." />}
      {!tile.copying && !isCopied && !tile.error && <CopyWaiting />}
      {tile.error && <CopyError errorMessage={tile.error} />}
      {isCopied && <Copied />}
    </ValidationItemContainer>
  );
};
